module.exports = __webpack_public_path__ + "static/img/diagnosis_chart.455caf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/diagnosis_chart.png
// module id = ewH9
// module chunks = 1